// import './PrivacyPolicy.css'
// export const TermsOfService = () => {
//     return(
//         <div className="privacy-policy-main">
    
      
//       {/* Hero Section */}
//       <section className="privacy-policy-hero-section">
//         <div className="absolute-inset-0-bg-black-10"></div>
//         <div className="relative-max-w-4xl-mx-auto-px-4-sm-px-6-lg-px-8-text-center">
//           <h1 className="text-4xl-md-text-5xl-font-bold-text-white-mb-4">
//             Köpvillkor & Ångerrätt
//           </h1>
//           <p className="text-xl-text-white-90">
//             Sandra's Hälsa – Villkor för digitala tjänster och medlemskap
//           </p>
//         </div>
//       </section>

//       <main className="max-w-4xl-mx-auto-px-4-sm-px-6-lg-px-8-py-16">
//         <div className="bg-card-rounded-2xl-shadow-lg-p-8-md-p-12">
//           <div className="space-y-8">
            
//             <div className="bg-gradient-to-r-from-f39e60-10-to-e16a54-10-rounded-xl-p-6-border-l-4-border-f39e60">
//               <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
//                 <span className="bg-f39e60-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">1</span>
//                 Digitala tjänster och samtal online
//               </h2>
//               <div className="text-muted-foreground-mb-4">
//                 <p>
//                   När du köper en digital tjänst (t.ex. samtalsterapi, coaching eller kursmaterial) gäller 
//                   distansavtalslagen.
//                 </p>
//                 <p>
//                   Enligt lagen har du som konsument normalt 14 dagars ångerrätt.
//                 </p>
//                 <p>
//                   <strong className="text-foreground">Men:</strong> Eftersom våra tjänster levereras digitalt och/eller påbörjas direkt, upphör ångerrätten så 
//                   snart tjänsten har börjat levereras.
//                 </p>
//                 <p>Genom att genomföra ditt köp godkänner du därför att:</p>
//                 <ul className="space-y-2-mt-3">
//                   <li className="flex-items-start">
//                     <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                     <span className="text-foreground">leveransen kan påbörjas direkt, och</span>
//                   </li>
//                   <li className="flex-items-start">
//                     <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                     <span className="text-foreground">din ångerrätt upphör i samband med detta.</span>
//                   </li>
//                 </ul>
//               </div>
//             </div>

//             <div className="bg-gradient-to-r-from-e16a54-10-to-7c444f-10-rounded-xl-p-6-border-l-4-border-e16a54">
//               <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
//                 <span className="bg-e16a54-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">2</span>
//                 Viktigt att veta vid bokning hos Sandra's hälsa
//               </h2>
//               <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
//                 <ul className="space-y-3">
//                   <li className="flex-items-start">
//                     <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                     <span className="text-foreground">
//                       När du bokar en tid eller köper en digital tjänst påbörjas leveransen direkt. Därför 
//                       gäller ingen ångerrätt enligt distansavtalslagen.
//                     </span>
//                   </li>
//                   <li className="flex-items-start">
//                     <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                     <span className="text-foreground">
//                       Du kan avboka eller omboka kostnadsfritt fram till 24 timmar före bokad tid. 
//                       Därefter debiteras hela beloppet.
//                     </span>
//                   </li>
//                   <li className="flex-items-start">
//                     <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                     <span className="text-foreground">
//                       När du genomför bokningen godkänner du dessa villkor.
//                     </span>
//                   </li>
//                 </ul>
                
//                 {/* <div className="mt-6 bg-gradient-to-r from-green-50 to-green-100 border border-green-200 rounded-lg p-4">
//                   <div className="flex items-center gap-2">
//                     <span className="text-green-600 font-bold text-lg">✅</span>
//                     <span className="text-green-800 font-medium">
//                       Jag godkänner villkoren och att ångerrätten upphör när tjänsten startar
//                     </span>
//                   </div>
//                 </div> */}
//               </div>
//             </div>

//             <div className="bg-gradient-to-r-from-7c444f-10-to-f39e60-10-rounded-xl-p-6-border-l-4-border-7c444f">
//               <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
//                 <span className="bg-7c444f-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">3</span>
//                 Villkor för medlemskap – Sandra's hälsa
//               </h2>
//               <div className="space-y-6-text-muted-foreground-leading-relaxed">
                
//                 <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
//                   <h3 className="text-lg font-semibold text-[#F39E60] mb-3">Bindningstid och betalning</h3>
//                   <ul className="space-y-3">
//                     <li className="flex-items-start">
//                       <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                       <span className="text-foreground">Medlemskapet löper månadsvis och förnyas automatiskt om inget annat anges.</span>
//                     </li>
//                     <li className="flex-items-start">
//                       <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                       <span className="text-foreground">Ingen bindningstid – du kan avsluta ditt medlemskap när du vill, och det gäller då till och med den redan betalda perioden.</span>
//                     </li>
//                     <li className="flex-items-start">
//                       <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                       <span className="text-foreground">Betalning sker i förskott för varje medlemsperiod</span>
//                     </li>
//                   </ul>
//                 </div>

//                 <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
//                   <h3 className="text-lg-font-semibold-text-[#E16A54]-mb-3">Uppsägning</h3>
//                   <ul className="space-y-3">
//                     <li className="flex-items-start">
//                       <span className="w-2-h-2-bg-7c444f-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                       <span className="text-foreground">Uppsägning görs via e-post: <a href="mailto:info@sandrashalsa.se" className="text-[#F39E60] hover:underline font-medium">info@sandrashalsa.se</a></span>
//                     </li>
//                     <li className="flex-items-start">
//                       <span className="w-2-h-2-bg-7c444f-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
//                       <span className="text-foreground">Avslutat medlemskap gäller från och med nästa period – du har alltid kvar tillgång till materialet under den tid du redan betalat för.</span>
//                     </li>
//                   </ul>
//                 </div>

//                 <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
//                   <h3 className="text-lg-font-semibold-text-[#7C444F]-mb-3">Ångerrätt</h3>
//                   <div className="space-y-3-text-foreground">
//                     <p>
//                       När du tecknar medlemskap online gäller distansavtalslagen. Som konsument 
//                       har du normalt 14 dagars ångerrätt.
//                     </p>
//                     <p>
//                       Eftersom medlemskapet ger dig direkt tillgång till digitalt innehåll och 
//                       tjänster upphör ångerrätten i samband med att medlemskapet aktiveras, om du 
//                       samtycker till detta vid köpet.
//                     </p>
//                     <p>
//                       Ditt medlemskap förnyas månadsvis och du kan när som helst avsluta inför 
//                       nästa period.
//                     </p>
//                   </div>
//                 </div>

//                 {/* <div className="bg-gradient-to-r from-green-50 to-green-100 border border-green-200 rounded-lg p-4">
//                   <div className="flex items-center gap-2">
//                     <span className="text-green-600 font-bold text-lg">✅</span>
//                     <span className="text-green-800 font-medium">
//                       Jag samtycker till att mitt medlemskap startar direkt och att ångerrätten därmed inte gäller
//                     </span>
//                   </div>
//                 </div> */}
//               </div>
//             </div>

//           </div>
//         </div>

        
//         <div className="mt-8-bg-gradient-to-r-from-e16a54-to-7c444f-rounded-xl-p-8-text-white">
//           <h2 className="text-2xl-font-bold-mb-4-flex-items-center">
//             <span className="bg-white-20-backdrop-blur-sm-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">4</span>
//             Kontakt
//           </h2>
//           <p className="mb-6-text-white-90">
//             Har du frågor om våra köpvillkor är du välkommen att kontakta oss:
//           </p>
//           <div className="bg-white-10-backdrop-blur-sm-rounded-lg-p-6-border-border-white-20">
//             <h3 className="font-bold-text-f39e60-text-lg-mb-2">Sandra's Hälsa</h3>
//             <p className="text-white-90">E-post: info@sandrashalsa.se</p>
//           </div>
//         </div>
//       </main>
     
//     </div>
//     )
// }

import './PrivacyPolicy.css'
interface ITermsOfService{
  showContact?:boolean;
}
export const TermsOfService = ({showContact}:ITermsOfService) => {
  return (
    <div className="privacy-policy-main">
      {/* Hero Section */}
      <section className="privacy-policy-hero-section">
        <div className="absolute-inset-0-bg-black-10"></div>
        <div className="relative-max-w-4xl-mx-auto-px-4-sm-px-6-lg-px-8-text-center">
          <h1 className="text-4xl-md-text-5xl-font-bold-text-white-mb-4">
            Köpvillkor &amp; Ångerrätt
          </h1>
          <p className="text-xl-text-white-90">
            Sandras Hälsa – Villkor för digitala tjänster, bokningar och medlemskap
          </p>
        </div>
      </section>

      <main className="max-w-4xl-mx-auto-px-4-sm-px-6-lg-px-8-py-16">
        <div className="bg-card-rounded-2xl-shadow-lg-p-8-md-p-12">
          <div className="space-y-8">
            {/* Section 1 */}
            <div className="bg-gradient-to-r-from-f39e60-10-to-e16a54-10-rounded-xl-p-6-border-l-4-border-f39e60">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-f39e60-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">
                  1
                </span>
                Digitala tjänster och samtal online
              </h2>
              <div className="text-muted-foreground-mb-4">
                <p>
                  När du köper en digital tjänst (t.ex. samtalsterapi, coaching eller kursmaterial) gäller distansavtalslagen.
                </p>
                <p>
                  Enligt lagen har du som konsument normalt 14 dagars ångerrätt.
                </p>
                <p>
                  <strong className="text-foreground">Men:</strong> Eftersom våra tjänster levereras digitalt och/eller påbörjas direkt, upphör ångerrätten så snart tjänsten har börjat levereras.
                </p>
                <p>Genom att genomföra ditt köp godkänner du därför att:</p>
                <ul className="space-y-2-mt-3">
                  <li className="flex-items-start">
                    <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                    <span className="text-foreground">leveransen kan påbörjas direkt, och</span>
                  </li>
                  <li className="flex-items-start">
                    <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                    <span className="text-foreground">din ångerrätt upphör i samband med detta.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 2 */}
            <div className="bg-gradient-to-r-from-e16a54-10-to-7c444f-10-rounded-xl-p-6-border-l-4-border-e16a54">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-e16a54-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">
                  2
                </span>
                Viktigt att veta vid bokning hos Sandras Hälsa
              </h2>
              <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
                <ul className="space-y-3">
                  <li className="flex-items-start">
                    <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                    <span className="text-foreground">
                      När du bokar en tid eller köper en digital tjänst påbörjas leveransen direkt. Därför gäller ingen ångerrätt enligt distansavtalslagen.
                    </span>
                  </li>
                  <li className="flex-items-start">
                    <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                    <span className="text-foreground">
                      Du kan avboka eller omboka kostnadsfritt fram till 24 timmar före bokad tid. Därefter debiteras hela beloppet.
                    </span>
                  </li>
                  <li className="flex-items-start">
                    <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                    <span className="text-foreground">
                      När du genomför bokningen godkänner du dessa villkor.
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 3 */}
            <div className="bg-gradient-to-r-from-7c444f-10-to-f39e60-10-rounded-xl-p-6-border-l-4-border-7c444f">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-7c444f-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">
                  3
                </span>
                Villkor för medlemskap – Sandras Hälsa
              </h2>
              <div className="space-y-6-text-muted-foreground-leading-relaxed">
                <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
                  <h3 className="text-lg font-semibold text-[#F39E60] mb-3">Bindningstid och betalning</h3>
                  <ul className="space-y-3">
                    <li className="flex-items-start">
                      <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                      <span className="text-foreground">Medlemskapet löper månadsvis och förnyas automatiskt om inget annat anges.</span>
                    </li>
                    <li className="flex-items-start">
                      <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                      <span className="text-foreground">Ingen bindningstid – du kan avsluta ditt medlemskap när du vill, och det gäller då till och med den redan betalda perioden.</span>
                    </li>
                    <li className="flex-items-start">
                      <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                      <span className="text-foreground">Betalning sker i förskott för varje medlemsperiod.</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
                  <h3 className="text-lg font-semibold text-[#E16A54] mb-3">Uppsägning</h3>
                  <ul className="space-y-3">
                    <li className="flex-items-start">
                      <span className="w-2-h-2-bg-7c444f-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                      <span className="text-foreground">
                        Uppsägning görs via e-post:{' '}
                        <a href="mailto:info@sandrashalsa.se" className="text-[#F39E60] hover:underline font-medium">
                          info@sandrashalsa.se
                        </a>
                      </span>
                    </li>
                    <li className="flex-items-start">
                      <span className="w-2-h-2-bg-7c444f-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                      <span className="text-foreground">Avslutat medlemskap gäller från och med nästa period – du har alltid kvar tillgång till materialet under den tid du redan betalat för.</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
                  <h3 className="text-lg font-semibold text-[#7C444F] mb-3">Ångerrätt</h3>
                  <div className="space-y-3-text-foreground">
                    <p>
                      När du tecknar medlemskap online gäller distansavtalslagen. Som konsument har du normalt 14 dagars ångerrätt.
                    </p>
                    <p>
                      Eftersom medlemskapet ger dig direkt tillgång till digitalt innehåll och tjänster upphör ångerrätten i samband med att medlemskapet aktiveras, om du samtycker till detta vid köpet.
                    </p>
                    <p>
                      Ditt medlemskap förnyas månadsvis och du kan när som helst avsluta inför nästa period.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        {typeof showContact === 'undefined' && 
          <div className="mt-8-bg-gradient-to-r-from-e16a54-to-7c444f-rounded-xl-p-8-text-white">
          <h2 className="text-2xl-font-bold-mb-4-flex-items-center">
            <span className="bg-white-20-backdrop-blur-sm-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">
              4
            </span>
            Kontakt
          </h2>
          <p className="mb-6-text-white-90">
            Har du frågor om våra köpvillkor är du välkommen att kontakta oss:
          </p>
          <div className="bg-white-10-backdrop-blur-sm-rounded-lg-p-6-border-border-white-20">
            <h3 className="font-bold-text-f39e60-text-lg-mb-2">Sandras Hälsa</h3>
            <p className="text-white-90">E-post: info@sandrashalsa.se</p>
          </div>
        </div>
        }
        
      </main>
    </div>
  )
}